import { createValidator } from "../../utils/validation";
import { CorporateStructureSchema , certifiedStructureChartQuestion, oustandingdetailschema, isUbo25Identifiedquestion, lastschema} from "../validationRules/validateCorporateStructure";
import { UBOTypeSelectSchema } from "../validationRules/validateUBOForm";
import { useValidateUBOForm } from "./useValidateUBOForm";
import { isSectionSkipped } from "../../utils/navigationHelper";

export const useValidateCorporateStrcuture = () => {

    const { validateUBOForm } = useValidateUBOForm()

    const validateCorporateStructure = (formData) => {
        // Skip only when the section genuinely does not apply — Simplified AND no data
        // saved. Once anything is saved the section is required, so it must be validated
        // like any other; skipping validation there would leave the user unable to see
        // what is missing while the sign-off gate blocks on it.
        if (isSectionSkipped("corporate")) return {};

        let customValidator = { ...CorporateStructureSchema };

        if (formData.isUbo25Identified === "Yes") {
            customValidator = { ...customValidator, ...UBOTypeSelectSchema };
        }

        if (formData.certifiedStructureChart === "No") {
            customValidator = {...certifiedStructureChartQuestion, ...customValidator };
        }
        if (formData.outstandingConcern === "yes") {
            customValidator = {...oustandingdetailschema, ...customValidator };
        }

        if (formData.isUbo25Identified === "No") {
            customValidator = {...isUbo25Identifiedquestion, ...customValidator };
        }

        if (formData.managedByOne === "No") {
            customValidator = {...lastschema, ...customValidator };
        }

        return createValidator(customValidator)(formData);
    }

    const validateUBO = (formData) => {
        if (isSectionSkipped("corporate")) return {};
        // formData is uboState in actual
        return validateUBOForm(formData);

    }

    return { validateCorporateStructure, validateUBO }
}